import { isReactNative } from 'yofobasement/utils/runtime';
let NativeModules = {};
if (isReactNative()) {
  NativeModules = require('react-native').NativeModules;
}
export default NativeModules;



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/NativeModules.js